import React from 'react';
import classNames from 'classnames';
import HotelCardLabel from '../HotelCardLabel';
import type { LabelVariantValue } from '../../types';
import styles from './hotelCardLabels.module.css';

type HotelCardLabelsProps = {
  labels: LabelVariantValue[];
  isMobile: boolean;
};

const HotelCardLabels: React.FC<HotelCardLabelsProps> = ({
  labels,
  isMobile,
}) => {
  if (!labels.length) return null;

  return (
    <div
      className={classNames(styles.labelsContainer, {
        [styles.labelsContainerMobile]: isMobile,
        [styles.labelsContainerDesktop]: !isMobile,
      })}
    >
      {labels.map(({ id, text, tooltipText }) => (
        <HotelCardLabel key={id} labelText={text} tooltipText={tooltipText} />
      ))}
    </div>
  );
};

export default HotelCardLabels;
